import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AppShell from "../components/AppShell";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { accessLead, formatErr, session } from "../lib/api";

export default function Access() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !code) {
      toast.error("Email y código son obligatorios");
      return;
    }
    setLoading(true);
    try {
      const lead = await accessLead(email, code);
      session.save(lead);
      toast.success("Bienvenido de vuelta");
      navigate("/panel");
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppShell showBack title="Accede a tu panel" withBottomNav={false}>
      <form onSubmit={handleSubmit} className="px-5 pb-6 space-y-4" data-testid="access-form">
        <p className="text-sm text-slate-600 -mt-1">
          Ingresa el email y el código de 6 dígitos que recibiste al crear tu proyecto.
        </p>

        <div className="space-y-1.5">
          <Label className="text-sm">Email</Label>
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="tu@email.com"
            data-testid="input-access-email"
            required
          />
        </div>
        <div className="space-y-1.5">
          <Label className="text-sm">Código de acceso</Label>
          <Input
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
            placeholder="000000"
            inputMode="numeric"
            className="tracking-[0.5em] text-center font-semibold text-lg"
            data-testid="input-access-code"
            required
          />
        </div>

        <Button
          type="submit"
          disabled={loading}
          className="btn-primary h-12 rounded-xl w-full font-semibold"
          data-testid="btn-access-submit"
        >
          {loading ? "Verificando..." : "Entrar"}
        </Button>

        <button
          type="button"
          onClick={() => navigate("/formulario")}
          className="block mx-auto text-sm text-slate-500 underline underline-offset-4"
          data-testid="btn-no-account"
        >
          ¿No tienes proyecto aún? Comenzar
        </button>
      </form>
    </AppShell>
  );
}
